"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUnsafeNewsroomUpdateErrorResponse = isUnsafeNewsroomUpdateErrorResponse;
function isUnsafeNewsroomUpdateErrorResponse(value) {
  return value && value.status === 'error' && value.code === 'unsafe' && typeof value.message === 'string' && value.errors && value.errors[':global'] && Array.isArray(value.errors[':global']) && value.errors[':global'].every(error => error && typeof error.code === 'string' && typeof error.message === 'string');
}